module.exports = __webpack_public_path__ + "res/img_reward_b.44b156d44fcbc6be3046d73bea14aefe.png";